import { Toast } from "../../../../components/Common/Toast";
import { callAPI } from "../../../../services/api.service";

export const fetchMidJourneyStats = async (pageNumber: number) => {
    try {
        const response = await callAPI(`admin/image-gen-stats/?pageNumber=${pageNumber}`);
        return {
            stats: response?.books || [],
            totalPages: response?.totalPages || 0,
        };
    } catch (error) {
        Toast("Something went wrong while fetching MidJourney stats", true);
        throw error;
    }
};

export const searchMidJourneyStats = async (searchTerm: string) => {
    try {
        const response = await callAPI(`api/error-log/error-search?searchTerm=${searchTerm}`);
        return response?.message || [];
    } catch (error) {
        Toast("Error searching MidJourney stats", true);
        throw error;
    }
};
